import { isVerbose, setVerbose } from './logger';

/**
 * Utility function to check if verbose mode is enabled via CLI flags
 * Checks for --verbose or -v flags in process.argv
 */
export function isVerboseMode(): boolean {
  return process.argv.includes('--verbose') || process.argv.includes('-v');
}

// Re-export logger functions
export { isVerbose, setVerbose };
